import { atom } from "jotai";
import { SelectedStepSection } from "../types/IFormData";

export const selectedSectionAtom = atom<SelectedStepSection | null>(null);
